import React from 'react'
import { clientData } from '../data/data'
export default function Testimonios() {
    return (
        <>
            <div className="container">
                <div className="row">
                    <div className="col-lg-4 col-md-6 col-12">
                        <div className="row g-4">
                            {clientData.slice(0, 2).map((item, index) => {
                                return (
                                    <div className="col-12" key={index}>
                                        <div className="position-relative overflow-hidden z-1 bg-white rounded shadow p-4">
                                            <div className="d-flex align-items-center justify-content-between">
                                                <h6 className="mb-0">{item.tag}</h6>

                                                <ul className="list-unstyled mb-0 text-warning">
                                                    {item.rate.map((el, index) => {
                                                        return (
                                                            <li className="list-inline-item" key={index}><i className={el}></i></li>
                                                        )
                                                    })}
                                                </ul>
                                            </div>
                                            <p className="text-muted fst-italic mt-2">" {item.desc} "</p>
                                            <div className="d-flex align-items-center">
                                                <div className="ms-2">
                                                    <h6 className="text-dark small mb-0">{item.name}</h6>
                                                    <small className="text-muted d-block">{item.position}</small>
                                                </div>
                                            </div>

                                            <i className="mdi mdi-format-quote-open text-primary position-absolute top-50 start-50 translate-middle z-n1 testi-icon"></i>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 col-12 mt-4 mt-md-0">
                        <div className="row g-4">
                            {clientData.slice(2, 4).map((item, index) => {
                                return (
                                    <div className="col-12" key={index}>
                                        <div className="position-relative overflow-hidden z-1 bg-white rounded shadow p-4">
                                            <div className="d-flex align-items-center justify-content-between">
                                                <h6 className="mb-0">{item.tag}</h6>
                                                <ul className="list-unstyled mb-0 text-warning">
                                                    {item.rate.map((el, index) => {
                                                        return (
                                                            <li className="list-inline-item" key={index}><i className={el}></i></li>
                                                        )
                                                    })}
                                                </ul>
                                            </div>
                                            <p className="text-muted fst-italic mt-2">" {item.desc} "</p>
                                            <div className="d-flex align-items-center">
                                                <div className="ms-2">
                                                    <h6 className="text-dark small mb-0">{item.name}</h6>
                                                    <small className="text-muted d-block">{item.position}</small>
                                                </div>
                                            </div>

                                            <i className="mdi mdi-format-quote-open text-primary position-absolute top-50 start-50 translate-middle z-n1 testi-icon"></i>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>

                    <div className="col-lg-4 col-12 mt-4 mt-lg-0">
                        <div className="row g-4">
                            {clientData.slice(4, 6).map((item, index) => {
                                return (
                                    <div className="col-lg-12 col-md-6" key={index}>
                                        <div className="position-relative overflow-hidden z-1 bg-white rounded shadow p-4">
                                            <div className="d-flex align-items-center justify-content-between">
                                                <h6 className="mb-0">{item.tag}</h6>
                                                <ul className="list-unstyled mb-0 text-warning">
                                                    {item.rate.map((el, index) => {
                                                        return (
                                                            <li className="list-inline-item" key={index}><i className={el}></i></li>
                                                        )
                                                    })}
                                                </ul>
                                            </div>
                                            <p className="text-muted fst-italic mt-2">" {item.desc} "</p>
                                            <div className="d-flex align-items-center">
                                                <div className="ms-2">
                                                    <h6 className="text-dark small mb-0">{item.name}</h6>
                                                    <small className="text-muted d-block">{item.position}</small>
                                                </div>
                                            </div>

                                            <i className="mdi mdi-format-quote-open text-primary position-absolute top-50 start-50 translate-middle z-n1 testi-icon"></i>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}
